import { shine } from '@shinetools/invoicing-calculation'

import type { ImportedInvoiceReviewTotals } from '../types/importedInvoiceLineAmounts'

export interface ImportedInvoiceReviewTotalsLine {
  amountExclVat: number | null
  /** A fraction, e.g. `0.25`. */
  vatRate: number | null
}

/** A line without an amount adds nothing; one without a VAT rate counts as 0%. */
export const getImportedInvoiceReviewTotals = (
  lines: ImportedInvoiceReviewTotalsLine[],
  currency: string | null,
): ImportedInvoiceReviewTotals => {
  const lineInputs = lines.flatMap(({ amountExclVat, vatRate }) =>
    amountExclVat === null ? [] : [new shine.model.InvoiceLineInput(String(amountExclVat), '1', String(vatRate ?? 0))],
  )
  const { totalGrossAmount, totalNetAmount, totalVatAmount } = shine.Invoice.calculate(
    lineInputs,
    undefined,
    currency ?? undefined,
  )

  return {
    totalAmountExclVat: Number(totalNetAmount),
    totalAmountInclVat: Number(totalGrossAmount),
    totalVatAmount: Number(totalVatAmount),
  }
}
